import {

    FETCH_SIMCARDS_PENDING,
    FETCH_SIMCARDS_FULFILLED,
    FETCH_SIMCARDS_REJECTED,

    FETCH_SIMCARD_PENDING,
    FETCH_SIMCARD_FULFILLED,
    FETCH_SIMCARD_REJECTED,

    CREATE_SIMCARD_PENDING,
    CREATE_SIMCARD_FULFILLED,
    CREATE_SIMCARD_REJECTED,

    UPDATE_SIMCARD_PENDING,
    UPDATE_SIMCARD_FULFILLED,
    UPDATE_SIMCARD_REJECTED,

    DELETE_SIMCARD_PENDING,
    DELETE_SIMCARD_FULFILLED,
    DELETE_SIMCARD_REJECTED,
    
    CHANGE_SIMCARD,
    
    ADD_SIMCARD

} from './simCardActions'

const titleCase = (str) => {
    if (!str) return;
    return `${str}`.toLowerCase().split(' ').map(function(word) {
        return (word.charAt(0).toUpperCase() + word.slice(1));
    }).join(' ');
}

const initialState = {
    loading: false,
    listOfSimCards: [],
    simCard: {
        codigo: 0,
        matriz: 0,
        fornecedor: 0,
        iccid: "",
        ddd: 11,
        numero: "",
        pin: "",
        puk: "",
        contrato: "",
        operadora: 0,
        tipoPacote: 0,
        clienteMatriz: {
            codigo: 0,
            razaoSocial: '',
        }
    },
    error: null,
}

export function simCardReducer(state = initialState, action) {
    switch (action.type) {
        case CHANGE_SIMCARD: 
            let value = ""
                
            if (action.payload.name.includes('mail')) {
                value = action.payload.value.toLowerCase();
            } else 
                if (action.payload.name.includes('apelido')) {
                    value = action.payload.value;
                } else {
                    value = titleCase(action.payload.value);
                }

            return Object.assign({}, state, {
                simCard: { ...state.simCard, 
                    [action.payload.name]: value
                }
            })
        case ADD_SIMCARD: 
            return Object.assign({}, state, {
                simCard: { ...initialState.simCard }
            })
        case FETCH_SIMCARDS_PENDING:
            return Object.assign({}, state, {
                loading: true,
                listOfSimCards: [],
            })
        case FETCH_SIMCARDS_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
                listOfSimCards: action.payload
            })
        case FETCH_SIMCARDS_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        case CREATE_SIMCARD_PENDING:
            return Object.assign({}, state, {
                loading: true,
                //simCard: { ...initialState.simCard },
            })
        case CREATE_SIMCARD_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
                simCard: action.payload
            })
        case CREATE_SIMCARD_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        case UPDATE_SIMCARD_PENDING:
            return Object.assign({}, state, {
                loading: true,
            })
        case UPDATE_SIMCARD_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
                simCard: action.payload
            })
        case UPDATE_SIMCARD_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        case FETCH_SIMCARD_PENDING:
            return Object.assign({}, state, {
                loading: true,
            })
        case FETCH_SIMCARD_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
                simCard: action.payload
            })
        case FETCH_SIMCARD_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        case DELETE_SIMCARD_PENDING:
            return Object.assign({}, state, {
                loading: true,
            })
        case DELETE_SIMCARD_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
            })
        case DELETE_SIMCARD_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        default:
            return state
    }
}